import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedCurrency from 'I18n/components/FormattedCurrency';
import { getQuoteProperty } from 'quotes-ui-lib/utils/utils';
import { getStatusConfig } from 'quotes-ui-lib/utils/status';
import UIStatusTag from 'UIComponents/tag/UIStatusTag';
import { QUOTE_SETTINGS, QUOTE_TOTAL_DISPLAY_PREFERENCE_KEYS } from 'quotes-ui-lib/constants/quoteSettings';
import { useFetchQuoteSetting } from 'quotes-ui-lib/hooks/useFetchQuoteSetting';
import UIIcon from 'UIComponents/icon/UIIcon';
import Small from 'UIComponents/elements/Small';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const QuoteHighlightDetails = ({
  quote,
  allowPayBeforeEsign
}) => {
  const statusConfig = getStatusConfig(quote, allowPayBeforeEsign);
  const quoteTotalDisplayPreferenceSetting = useFetchQuoteSetting({
    quoteSettingKey: QUOTE_SETTINGS.QUOTE_TOTAL_DISPLAY_PREFERENCE
  });
  const quoteAmount = getQuoteProperty(quote, quoteTotalDisplayPreferenceSetting.value);
  if (!statusConfig) return null;
  return /*#__PURE__*/_jsxs("div", {
    className: "text-left m-y-4",
    children: [/*#__PURE__*/_jsx("h3", {
      className: "m-bottom-2",
      children: getQuoteProperty(quote, 'hs_title')
    }), /*#__PURE__*/_jsxs("div", {
      className: "m-bottom-1",
      children: [quoteTotalDisplayPreferenceSetting.loading && /*#__PURE__*/_jsx(UILoadingSpinner, {
        style: {
          margin: '0'
        },
        size: "xs"
      }), !quoteTotalDisplayPreferenceSetting.loading && /*#__PURE__*/_jsxs(_Fragment, {
        children: [quoteTotalDisplayPreferenceSetting.value === QUOTE_TOTAL_DISPLAY_PREFERENCE_KEYS.HS_TCV ? /*#__PURE__*/_jsx(FormattedMessage, {
          className: "m-right-1",
          message: "quotesHighlightCard.propertyLabels.totalContractValue"
        }) : /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            className: "m-right-1",
            message: "quotesHighlightCard.propertyLabels.quoteAmount"
          }), quoteTotalDisplayPreferenceSetting.error && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(UIIcon, {
              className: "m-right-1",
              color: "red",
              name: "warning"
            }), /*#__PURE__*/_jsx(Small, {
              use: "error",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "quotesUiLib.quoteTotalDisplayPreference.loadQuoteSettingErrorTooltip"
              })
            })]
          })]
        }), quoteAmount ? /*#__PURE__*/_jsx(FormattedCurrency, {
          value: Number(quoteAmount),
          currencyCode: getQuoteProperty(quote, 'hs_currency')
        }) : /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("span", {
            children: "--"
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(UIIcon, {
            className: "m-right-1",
            color: "red",
            name: "warning"
          }), /*#__PURE__*/_jsx(Small, {
            use: "error",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "quotesUiLib.quoteTotalDisplayPreference.quoteAmountErrorTooltip"
            })
          })]
        })]
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "m-bottom-1",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        className: "m-right-1",
        message: "quotesHighlightCard.propertyLabels.number"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "quotesHighlightCard.propertyValues.number",
        options: {
          number: getQuoteProperty(quote, 'hs_quote_number')
        }
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "m-bottom-1",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        className: "m-right-1",
        message: "quotesHighlightCard.propertyLabels.status"
      }), /*#__PURE__*/_jsx(UIStatusTag, {
        use: statusConfig.use,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: statusConfig.message,
          options: statusConfig.options
        })
      })]
    })]
  });
};
export default QuoteHighlightDetails;